import {AxiosResponse} from "axios";
import {PhoneNumber, UpdatePhoneNumber} from "@/services/models/PhoneNumber";
import BimsHttpService from "@/services/BimsHttpService";

class PhoneNumberService {
    /**
     * @description Retrieves all phone numbers for the organization with the specified id
     */
    getOrganizationPhoneNumbers(organizationId: string): Promise<PhoneNumber[]> {
        return BimsHttpService.get(`/organizations/${organizationId}/phoneNumbers`)
            .then((response: AxiosResponse<PhoneNumber[]>) => {
                    return response.data;
                }
            )
    }

    /**
     * @description Retrieves all phone numbers for the person with the specified id
     */
    getPersonPhoneNumbers(personId: string): Promise<PhoneNumber[]> {
        return BimsHttpService.get(`/people/${personId}/phoneNumbers`)
            .then((response: AxiosResponse<PhoneNumber[]>) => {
                    return response.data;
                }
            )
    }

    /**
     * @description Updates the organization phone numbers
     */
    UpdateOrganizationPhoneNumbers(organizationId: string, phoneNumbers: UpdatePhoneNumber[]): Promise<any> {
        return BimsHttpService.put(`/organizations/${organizationId}/phonenumbers`, phoneNumbers)
    }

    /**
     * @description Updates the person phone numbers
     */
    UpdatePersonPhoneNumbers(personId: string, phoneNumbers: UpdatePhoneNumber[]): Promise<any> {
        return BimsHttpService.put(`/people/${personId}/phonenumbers`, phoneNumbers)
    }
}

export default new PhoneNumberService()
